__webpack_public_path__ = window.WEBPACK_PUBLIC_PATH || ''